import { clearWorkspaceIcon } from "@/components/icons/SVGIcons";
import {
  returnCurrentTabID,
  returnCurrentTabStateJSON,
} from "@/lib/widgetHelperFunctions";
import workspacesTabsStore from "@/store/workspacesTabsStore";
import ToolTipMappedSVGandButton from "../Sidebar/ToolTipMappedSVGandButton";
import { clearWokspaceLayout } from "./helperFunctionsRGL";

const ClearLayoutsRGL = () => {
  const updateWholeTab = workspacesTabsStore((state) => state.updateWholeTab);

  function onClearLayout() {
    const currentTabStateJSON = returnCurrentTabStateJSON();

    const newState = clearWokspaceLayout(currentTabStateJSON);
    const currentTabId = returnCurrentTabID();

    if (currentTabId !== undefined) {
      updateWholeTab(newState, currentTabId);
    }
  }

  const buttonDetails = {
    displayName: "Clear",
    icon: clearWorkspaceIcon,
  };

  return (
    <ToolTipMappedSVGandButton
      button={buttonDetails}
      onClickAction={onClearLayout}
      dataTestID={"clear-layout-button"}
    />
  );
};

export default ClearLayoutsRGL;
